import SFetch from '@app/utils/sfetch'
import { requestStatus } from '@app/application/constants/comms'

const PAGE_VISIT_REGISTRATION_DELAY = 3000 // wait 3 seconds to make sure user has seen the content

export default {
  watch: {
    fetchingCommunicationsStatus(value, oldValue) {
      if (value === oldValue) {
        return
      }

      // in WF review, cancel the registering of the page visit if
      // the user hovers on another item, which will re-fetch the comms
      if (value === requestStatus.IN_PROGRESS) {
        clearTimeout(this.timeoutToClear)
        this.timeoutToClear = null
      }

      if (value === requestStatus.COMPLETED) {
        this.registerPageVisit()
      }
    },
  },
  created() {
    window.eventHub.$on('drawer:open', this.registerPageVisit)
    this.registerPageVisit()
  },

  beforeUnmount() {
    window.eventHub.$off('drawer:open', this.registerPageVisit)
  },
  methods: {
    registerPageVisit() {
      if (!this.isRightDrawerOpen) return

      const params = [
        Silverfin.currentFirmId,
        Silverfin.currentCompanyId,
        this.ledgerId,
        this.contextId,
      ]

      let url = null

      if (this.contextType === 'reconciliation_text') {
        url = Silverfin.Routes.reconciliation_text_ledger_page_visits_path(
          ...params
        )
      } else if (this.contextType === 'account') {
        url = Silverfin.Routes.account_ledger_page_visits_path(...params)
      }

      if (url && !this.timeoutToClear) {
        this.timeoutToClear = setTimeout(() => {
          SFetch.jsonWithAlert(url, { method: 'POST' }).then(
            () => (this.timeoutToClear = null)
          )
        }, PAGE_VISIT_REGISTRATION_DELAY)
      }
    },
  },
}
